import React from "react";
import { ColumnsType } from "antd/es/table";
import {
  ItemProps,
  OrderInventoryProps,
  TransactionLineProps,
  TransactionProps,
  RoleProps,
  UserDataProps,
  reportProps,
  ConnectionProps,
} from "../../interfaces/interfaces";
import { Button, Checkbox } from "antd";
import { EditFilled } from "@ant-design/icons";

export const OrderTableColumns: ColumnsType<TransactionProps> = [
  {
    title: "OID",
    dataIndex: "OID",
    key: "OID",
  },
  {
    title: "Edit",
    dataIndex: "X",
    render: () => <Button icon={<EditFilled />}></Button>,
  },
  {
    title: "Drilling Company",
    dataIndex: "DrillingCompany",
  },
  {
    title: "Rig Number",
    dataIndex: "RigNumber",
  },
  {
    title: "Serial Number",
    dataIndex: "SerialNumber",
  },
  {
    title: "PO #",
    dataIndex: "PurchaseOrderNo",
  },
  {
    title: "Estimate #",
    dataIndex: "EstimateNo",
  },
  {
    title: "Item",
    dataIndex: "ItemDetail",
    render: (params: ItemProps) => <>{params ? params.Name : ""}</>,
  },
  {
    title: "Status",
    dataIndex: "Status",
  },
  {
    title: "Connection",
    dataIndex: "ConnectionDetail",
    render: (params: ConnectionProps) => <>{params ? params.Name : ""}</>,
  },
  {
    title: "Date Received",
    dataIndex: "DateReceived",
    render: (params) => (
      <>{params ? new Date(params).toISOString().split("T")[0] : ""}</>
    ),
  },
  {
    title: "Date Repaired",
    dataIndex: "DateRepaired",
    render: (params) => (
      <>{params ? new Date(params).toISOString().split("T")[0] : ""}</>
    ),
  },
  {
    title: "Date Shipped",
    dataIndex: "DateShipped",
    render: (params) => (
      <>{params ? new Date(params).toISOString().split("T")[0] : ""}</>
    ),
  },
];

export const OrderLinesTableColumns: ColumnsType<TransactionLineProps> = [
  {
    title: "OID",
    dataIndex: "OID",
    key: "OID",
  },
  {
    title: "Edit",
    dataIndex: "X",
    render: () => <Button icon={<EditFilled />}></Button>,
  },
  {
    title: "Item Name",
    dataIndex: "itemDetail",
    width: "10vw",
    render: (params) => <>{params && params.Name ? params.Name : ""}</>,
  },
  {
    title: "Item Qty",
    dataIndex: "ItemQty",
  },
  {
    title: "Quantity",
    dataIndex: "Quantity",
  },
];

export const ItemTableColumns: ColumnsType<ItemProps> = [
  {
    title: "Edit",
    dataIndex: "X",
    render: () => <Button icon={<EditFilled />}></Button>,
  },
  {
    title: "Name",
    dataIndex: "Name",
  },
];

export const ConnectionTableColumns: ColumnsType<ConnectionProps> = [
  {
    title: "Edit",
    dataIndex: "X",
    render: () => <Button icon={<EditFilled />}></Button>,
  },
  {
    title: "Name",
    dataIndex: "Name",
  },
];

export const RoleTableColumns: ColumnsType<RoleProps> = [
  {
    title: "Name",
    dataIndex: "Name",
  },
  {
    title: "Is Administrative",
    dataIndex: "IsAdministrative",
    align: "center",
    render: (params) => <Checkbox checked={params} />,
  },
  {
    title: "Can Edit Model",
    dataIndex: "CanEditModel",

    render: (params) => <Checkbox checked={params} />,
  },
];

export const UserTableColumns: ColumnsType<UserDataProps> = [
  {
    title: "Username",
    dataIndex: "UserName",
  },
  {
    title: "Is Active",
    dataIndex: "IsActive",
    align: "center",
    render: (params) => <Checkbox checked={params} />,
  },
];

export const ReportTableColumns: ColumnsType<reportProps> = [
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "Data Type",
    dataIndex: "dataType",
  },
];
